
import { useState, useContext, useEffect } from 'react';
import { DashboardContext } from '../../../contextApi/DashboardContext.jsx';
import BranchCard_dropdown from './BranchCard_dropdown'
import BranchCard_activity from './BranchCard_activity';
import { AppContext } from '../../../contextApi/ContextApi.jsx';

export default function BranchCard({branch, index}) {
    const {accent_color, primary_color, currentWebsite, setToastMessage, messagesOptions } = useContext(AppContext);
    const {handleSetBranchData, branchUpdateFlag, handleBranchStatusChange, handleDeleteItem} = useContext(DashboardContext);
    const [branchStatus, setBranchStatus] = useState(branch?.isOpen || false);

    const [activityData, setActivityData] = useState(branch?.week || []);

    // Get the updated week data from child on triger change, and set the activity data
    const handleActivityChange = (updatedWeek) => {
        setActivityData(updatedWeek);
    };

    // Perform the open/close status of a branch
    useEffect(()=>{
        if(!branch || branch.isOpen === null || branch.isOpen === undefined || branch.isOpen === branchStatus) return;
        handleBranchStatusChange(currentWebsite, branch?._id, setToastMessage, messagesOptions);
    },[branchStatus])

    if(!branch) return null;
    return (
        <div className='branchCard' style={{backgroundColor:primary_color, color:accent_color}}>
            
            {/* if branch is closed => display X-button, else null */}
            {!branchStatus ?
                <div className='branchCard_dashboard_xBtn' style={{backgroundColor:accent_color, color:primary_color}} onClick={()=>{handleDeleteItem(currentWebsite.id, "settings.branches", branch, setToastMessage, messagesOptions)}}>x</div> :
                null
            }
            <h4>{branch.address}, {branch.city}</h4>

            {/* The dropdown to select if branch is open or closed */}
            <BranchCard_dropdown _class={"branchCard_dropDown"} label={"סטטוס פעילות"} action={()=>{setBranchStatus(!branchStatus)}} _value={branchStatus} id={`branchCard_dropdown_inx_${index}`} options={["סגור","פתוח"]}/>

            <h4>{branchStatus ? "ימי ושעות פעילות:" : "הסניף סגור"}</h4>

            {/* if branch is open => display activity, else null */}
            {branchStatus ? <BranchCard_activity branch={branch} index={index} onActivityChange={handleActivityChange}/> : null}

            {/* if branch is open => display the button that saves changes at activity */}
            {branchStatus ? 
                <button dir={"rtl"} disabled={branchUpdateFlag} className='branchCard_saveChanges' style={{backgroundColor:accent_color, color:primary_color}} onClick={()=>{handleSetBranchData(currentWebsite, branch?._id, activityData, setToastMessage, messagesOptions)}}>{branchUpdateFlag ? "המתן..." : "שמור"}</button> :
                null
            }
        </div>
    )
}
